// extracted by mini-css-extract-plugin
module.exports = {"footer__title":"style_footer__title___89ia"};